export default "__VITE_ASSET__CqmeLvyQ__"